<template lang="pug">
.header-top.main-container-wide(data-track="Header Top")
  rogue-link(to="/")
    img.top-header-logo(src="../../../assets/rogue-logo-gray.svg" alt="Rogue Fitness" width="90" height="14")
  SiteSelector
  .space
  rogue-link.giftcard(:to='giftCardLink[$rogue.site.code]' ) {{ __('Gift Cards') }}
  rogue-link(to='/contact-us') {{ __('Contact Us') }}
  rogue-link(to='/shippingtracker') {{ __('Order Status') }}
  live-chat.chat(v-if="hasLiveChat")
</template>

<script lang="ts" setup>
import SiteSelector from './country-select/site-selector.vue'
import { useLiveChat } from '@/js/composables/useLiveChat'

const { hasLiveChat } = useLiveChat()

const giftCardLink = {
  AUS : '/e-gift-cards-au',
  USA : '/gift-cards',
  APO : '/e-gift-cards',
  EUR : '/e-gift-cards-eu',
  GBR : '/e-gift-cards-eu',
  CAN : '/e-gift-cards',
}

</script>

<style lang="scss" scoped>
.header-top {
  padding: 0;
  display: none;
  position: relative;
  height: 38px;
  align-items: center;
  font-size: $size-xs;

  @include all-desktop() {
    display: flex;
  }
}

.header-top a {
  color: $color-gray-x-dark;
  cursor: pointer;
  text-decoration: none;
  padding: 0 $space-xxs;
  background: $color-white;

  &:first-child {
    padding-left: 0;
  }

  &:hover {
    text-decoration: underline;
    color: $color-black-light;
    background: $color-white;
  }
}

.space {
  flex-grow: 1;
}
</style>
